import { boutonFiltreFaqMock, detailsFaqMock, listingFaqMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [boutonFiltreFaqMock('/mock-faq-listing'), detailsFaqMock, listingFaqMock({ title: 'Suggestions' })];

export const faqDetailsMock: SlugPage = {
  ...pageBase({
    title: 'FAQ - Details',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
